import $ from "jquery";

export const eventHideNavMobileBg = () => {
    const navMobileBg = $('.nav-mobile__bg');

    $('.nav-mobile__list').scroll(function () {
        const topScroll = 50;
        let navMobileListScrolled = $(this).scrollTop();

        if (navMobileListScrolled > topScroll) {
            navMobileBg.hide();

            return;
        }

        navMobileBg.show();
    });
};
